import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { outlookIntegrationsQuery } from "modules/settings/lib/outlook/outlookIntegrationsQuery"
import {
  DataResponse,
  OutlookIntegrationsResponseDataSchema,
  SetOutlookMailboxesSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof OutlookIntegrationsResponseDataSchema>>

export function useSetOutlookMailboxesMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof SetOutlookMailboxesSchema>) => {
      const response = await axios.post<Response>(`/integrations/outlook/mailboxes`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: outlookIntegrationsQuery().queryKey })
    },
  })
}
